import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-modals-page',
    templateUrl: './modals-page.component.html',
    styleUrls: ['./modals-page.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ModalsPageComponent implements OnInit {

    public currOpenModalId: string;

    constructor () {}

    ngOnInit() {}

    public openModal(id: string, modalEl: any): void {

        this.currOpenModalId = id;
        modalEl.focus();
    }

    public closeModal(): void {
        this.currOpenModalId = null;
    }

    public isOpen(id: string): boolean {
        return this.currOpenModalId === id;
    }
}
